import { Button, ButtonProps } from "@admin/components/atoms/Button";
import useClickOutside from "@admin/hooks/useClickOutside";
import { useRef } from "react";

interface ButtonTooltipProps {
  id: string;
  title: string;
  description: string;
  buttons: ButtonProps[];
  isOpen: boolean; // Açık mı kapalı mı kontrolü için
  onClose: () => void; // Tooltip kapatıldığında çağrılacak fonksiyon
}

export function ButtonTooltip({
  id,
  title,
  description,
  buttons,
  isOpen,
  onClose,
  position,
}: ButtonTooltipProps & {
  isOpen: boolean;
  onClose: () => void;
  position: { top: number; left: number };
}) {
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref, onClose);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: position.top,
        left: position.left,
        width: "400px",
      }}
      ref={ref}
      className="shadow-default p-3 bg-light border border-[#F1F1F4] rounded-xl bg-white text-gray-700 text-xs font-normal"
    >
      <div className="flex flex-col gap-2.5 font-medium justify-start items-start bg-white p-4 ">
        <span>{title}</span>
        <div>{description}</div>
        <div className="flex gap-1">
          {buttons.map((button, index) => (
            <Button {...button} size="sm" key={index} />
          ))}
        </div>
      </div>
    </div>
  );
}
